module.exports = __webpack_public_path__ + "static/media/being_flying.ff297c47.png";